import LocationOnIcon from '@mui/icons-material/LocationOn';
import { FormattedMessage } from 'react-intl';

import { OfferAvailabilityLabel } from './offer-availability.component';
import { messages } from './offer-availability.messages';

export type AvailableAtLocationsProps = {
  count: number;
};

export const AvailableAtLocations = ({ count }: AvailableAtLocationsProps) => {
  if (count < 1) {
    return null;
  }

  return (
    <OfferAvailabilityLabel icon={LocationOnIcon}>
      <FormattedMessage {...messages['offer-availability:available-at-locations']} values={{ count }} />
    </OfferAvailabilityLabel>
  );
};
